import {AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {ICaseParticipantAttorneyFormGroup} from '../../services/forms/case-form/case-form.service';
import {ParticipantStatus} from '../../types/api/dot-net-api-types/data-contracts';

export function minActive(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fa = control as FormArray<FormGroup<ICaseParticipantAttorneyFormGroup>>;
    if (!control.value) {
      return null;
    }
    const activeAttorneys = fa.value.filter(a => a.status === ParticipantStatus.Active);
    return activeAttorneys.length >= min ? null : {'noActive': true};
  }
}
